module.exports = __webpack_public_path__ + "img/psaltire-1710-pagina-de-titlu-big.29727c50.jpg";